//lib
import { Icon } from "@iconify/react/dist/iconify.js";

//redux
import { useDispatch, useSelector } from "react-redux";

//component
import Col from "../../../components/element/col";
import Row from "../../../components/element/row";
import Image from "../../../components/element/image";
import { Logo, Sample } from "../../../assets/images";
import Button from "../../../components/element/button";
import ArrowButton from "../../../components/common/common.arrow.button";
import Container from "../../../components/element/container";
import CommonCart from "../../../components/common/common.cart";
import CommonSummary from "../../../components/common/common.summary";
import { useEffect, useState } from "react";
import OrderTimeline from "./order.timeline";
import OrderShipping from "./order.shipping";
import { handleCatchError } from "../../../helpers/handle.catch.error";
import { checkout } from "../../../redux/reducer/cart.reducer";
import { useSearchParams } from "react-router-dom";
import {
  closeFullLoading,
  openFullLoading,
} from "../../../redux/reducer/common.reducer";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { motion, AnimatePresence } from "framer-motion";

dayjs.extend(duration);

export default function OrderBasic({ order, key }) {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const { checkoutLoading } = useSelector((state) => state.cart);

  const [payAgainTime, setPayAgainTime] = useState("");
  const [expandOrder, setExpandOrder] = useState([]);

  const id = searchParams.get("order_id");
  const status = searchParams.get("status");

  const handlePayAgain = (e) => {
    e.stopPropagation();
    dispatch(openFullLoading());

    dispatch(
      checkout({
        order_id: order.id,
      })
    )
      .unwrap()
      .then((res) => {
        if (res.data?.payment_data?.result?.url) {
          window.parent.location.replace(res.data.payment_data.result.url);
        }
      })
      .catch((ex) => {
        dispatch(closeFullLoading());
        handleCatchError(ex, null);
      });
  };

  const handleExpandOrder = (index) => {
    setExpandOrder((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const isExpanded = expandOrder.includes(order.id);

  useEffect(() => {
    if (id && status && order?.invoice_number) {
      handleExpandOrder(Number(id));
      setSearchParams("");
    }
  }, [order]);

  useEffect(() => {
    const updateTimer = () => {
      if (!order?.created_at) return;

      const createdTime = dayjs(order.created_at, "DD MMM YYYY HH:mm");
      const expiresAt = createdTime.add(30, "minutes");
      const now = dayjs();
      const remaining = expiresAt.diff(now, "seconds");

      if (remaining <= 0) {
        setPayAgainTime("00:00");
        return;
      }

      const minutes = String(Math.floor(remaining / 60)).padStart(2, "0");
      const seconds = String(remaining % 60).padStart(2, "0");
      setPayAgainTime(`${minutes}:${seconds}`);
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [order.created_at]);

  return (
    <Container
      className={`order-basic ${isExpanded ? "--expanded" : ""} pointer`}
      key={key}
    >
      <Row
        className="_row title flex-nowrap gap-4 pointer"
        onClick={() => handleExpandOrder(order.id)}
      >
        <Row className="w-100 justify-between items-center ">
          <Col className="v-flex gap-2">
            <h3 className="_label order-id">Order #{order.invoice_number}</h3>
            <p className="_label order-date">
              {order.created_at}&nbsp;&nbsp;|&nbsp;&nbsp;
              <span
                className={`_label order-status --${
                  order.payment_status === "pending" ? "failed" : order.status
                }`}
              >
                {order.payment_status === "pending" ? "Unpaid" : order.status}
              </span>
            </p>
          </Col>
          {order.payment_status === "pending" && payAgainTime !== "00:00" && (
            <Button
              className="_button pay-again"
              disabled={checkoutLoading}
              onClick={(e) => handlePayAgain(e)}
            >
              <span>Pay again in </span>
              <AnimatePresence mode="popLayout">
                <motion.span
                  key={order.created_at}
                  initial={{ y: 10, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  exit={{ y: -10, opacity: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  {payAgainTime}
                </motion.span>
              </AnimatePresence>
            </Button>
          )}
        </Row>
        <Icon icon="iconamoon:arrow-down-2" className="_svg arrow" />
      </Row>
      <Row className="_row detail">
        <Col className="v-flex justify-between">
          <Col className="_col item-detail">
            {order.order_items?.length > 0 &&
              order.order_items.map((item, itemIndex) => (
                <CommonCart data={item} key={itemIndex} order />
              ))}
          </Col>
          <CommonSummary data={order} type="order" />
        </Col>
        <Col className="_col shipping-detail">
          <OrderTimeline order={order} />
          <OrderShipping order={order} />
        </Col>
      </Row>
    </Container>
  );
}
